<template lang="pug" src="./modal-contact.pug"></template>

<script>
export default {
  methods: {
    open () { this.$store.state.showModal ? this.$store.dispatch('VIEW_SHOWMODAL', false) : this.$store.dispatch('VIEW_SHOWMODAL', true) }
  }
}
</script>



// WEBPACK FOOTER //
// modal-contact.vue?e00931ce